function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr))
    return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
import { Loader } from '@nordlayer/rivendell-ui';
import NotFound from '@nordvpn/teams.core/lib/pages/404';
import PublicContainer from '@nordvpn/teams.core/lib/templates/PublicContainer';
import { RedirectByPermission } from 'components/navigation/RedirectToByPermission';
import { AuthRoutes } from 'routing/routes/auth';
import { Features } from 'types/features/enums';
import { useFeatureFlag } from 'utils/useFeatureFlag';
import { useAreFeaturesLoaded, useFeatureFlags } from 'api/FeatureFlags/queries';
import { SentryRoute } from './SentryRoute';
import { changeEmailInvitationRoute } from './routes/myProfile';
import { createUserPasswordInvitationRoute } from './routes/users';
import { jsx as _jsx } from "react/jsx-runtime";
var publicRoutes = [].concat(_toConsumableArray(AuthRoutes), _toConsumableArray(changeEmailInvitationRoute), _toConsumableArray(createUserPasswordInvitationRoute), [{
        pathname: '/',
        exact: true,
        component: function component() {
            return /*#__PURE__*/ _jsx(RedirectByPermission, {});
        }
    }, {
        component: function component() {
            return /*#__PURE__*/ _jsx(NotFound, {
                buttonText: "Back to Support Panel"
            });
        }
    }]);
export var PublicRouting = function PublicRouting() {
    useFeatureFlags({
        enabled: true
    });
    var areFeaturesLoaded = useAreFeaturesLoaded();
    var isUsersManagementEnabled = useFeatureFlag(Features.UsersManagement);
    var shouldRenderUsersManagement = areFeaturesLoaded && isUsersManagementEnabled;
    if (!areFeaturesLoaded) {
        return [/*#__PURE__*/ _jsx(Loader, {
                centered: true
            })];
    }
    return publicRoutes.map(function (_ref, key) {
        var pathname = _ref.pathname, Component = _ref.component, _ref$exact = _ref.exact, exact = _ref$exact === void 0 ? false : _ref$exact, containerProps = _ref.containerProps, componentProps = _ref.componentProps;
        return /*#__PURE__*/ _jsx(SentryRoute, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, pathname && {
            path: pathname
        }), {}, {
            exact: exact,
            key: key
        })), {}, {
            children: function children(props) {
                return !shouldRenderUsersManagement ? /*#__PURE__*/ _jsx(PublicContainer, _objectSpread(_objectSpread({}, containerProps), {}, {
                    children: /*#__PURE__*/ _jsx(Component, _objectSpread({}, _objectSpread(_objectSpread({}, props), componentProps)))
                })) : /*#__PURE__*/ _jsx(Component, _objectSpread({}, _objectSpread(_objectSpread({}, props), componentProps)));
            }
        }));
    });
};
